import React from "react";
import {useEffect, useState} from "react";
import {
    Alert, Button,
    Card, CircularProgress, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, Fab, Grid,
    IconButton,
    Snackbar
} from "@mui/material";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import styles from "../../../assets/css/page.module.scss";
import CustomTable from "../../../components/subComponents/Table";
import {styled} from "@mui/material/styles";
import {PersonApi} from "../../../utils/PersonApi";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import {useRef} from "react";
import LoadingButton from "../../../components/subComponents/LoadingButton";
import configs from "../../../utils/config.json";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const Input = styled('input')({
    display: 'none',
});

const fabStyle = {
    position: 'absolute',
    top: 30,
    right: 30,
};
const Slider = (props) => {
    const ref = useRef();
    const [rows, setRows] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [openSnackBar1, setOpenSnackBar1] = useState(false);
    const [message, setMessage] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [imageLoading, setImageLoading] = useState(false);
    const [sending, setSending] = useState(false);

    const handleClickSnackBar1 = (text) => {
        setOpenSnackBar1(true);
        setMessage(text);
    };
    const handleClose = () => {
        setOpenDialog(false);
    };
    const handleCloseSnackBar1 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar1(false);
    };


    const deletePerson = async (id) => {
        setDataLoading(true);
        await PersonApi.deletePerson(id, () => {
            handleClickSnackBar1('تصویر تماس حذف شد!');
            fetchData();

        }, () => {
        });
    }
    const fetchData = async () => {
        setDataLoading(true);
        await PersonApi.getAllPerson(
            (result) => {
                setRows(result.data);
                setDataLoading(false);
            },
            (error) => {
                setDataLoading(false);

            });

    }
    const sendDataToServer = async () => {
        setSending(true);
        const insert = async () => {
            let fd = new FormData();
            if (ref.current.files.length)
                fd.append("photo", ref.current.files[0]);
            await PersonApi.insertPerson(fd,
                async (result) => {
                    handleClickSnackBar1("تصویر افزوده شد.");
                    await sleep(3000);
                    setSending(false);
                    handleClose();
                    fetchData();
                },
                (error) => {
                    setSending(false);

                });
        }
        await insert();


    }

    const headers = [
        {
            field: 'title', title: 'تصویر', width: 250, renderCell: (row) => (
                <div>
                    <img src={`${configs.server.Storage}/${row.img}`} style={{width: 200, borderRadius: 10}}/>

                </div>
            ),
        },


        {
            field: 'userStatus', title: '---', width: 200,
            align: 'right',
            renderCell: (row) => (
                <>
                    <IconButton color="error" component="button" onClick={() => {
                        (async () => {
                            await deletePerson(row.id);
                        })();
                    }}>
                        <DeleteOutlineRoundedIcon/>
                    </IconButton>

                </>)
        },


    ];


    useEffect(() => {
        (async () => {
            await fetchData();
        })();


    }, []);


    return <div style={{padding: 15}}>
        <Card elevation={3} style={{height: 'calc(100vh - 30px)', direction: "rtl", overflow: "hidden"}}>
            <div className={styles.container}>
                <CustomTable headers={headers} rows={rows} loading={dataLoading} bottom={160}/>

            </div>
        </Card>
        <Dialog
            fullWidth
            maxWidth={"md"}
            open={(openDialog)}
            onClose={handleClose}
        >
            <DialogTitle>تصویر جدید</DialogTitle>
            <DialogContent>
                <DialogContentText>
                </DialogContentText>
                <Grid container>
                    <Grid item xs={12}>
                        <div style={{display: "flex", flexDirection: "row"}}>
                            <div style={{
                                width: "50%",
                                borderRadius: 15,
                                margin: 15,
                                overflow: "hidden",
                                position: "relative",
                                height: 300
                            }}>
                                <img id={"img1"}
                                     style={{
                                         width: "100%",
                                         position: "absolute",
                                         top: 0,
                                         height: "100%",
                                         zIndex: 1
                                     }}
                                     alt={""}
                                     src={'https://ndb-soft.com/wp-content/uploads/2020/06/placeholder.png'}/>
                                <div style={{
                                    top: 130,
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    position: "absolute",
                                    zIndex: 2
                                }}>
                                    {imageLoading && <CircularProgress/>}
                                </div>
                            </div>


                            <label htmlFor="img"
                                   style={{
                                       display: "flex",
                                       flexDirection: "column",
                                       justifyContent: "center",
                                       width: "50%"
                                   }}>
                                <Input accept="image/*" multiple type="file" ref={ref} id={"img"}
                                       onChange={e => {
                                           setImageLoading(true);
                                           let files = e.target.files; // FileList object

                                           // use the 1st file from the list
                                           let f = files[0];

                                           let reader = new FileReader();
                                           // Closure to capture the file information.
                                           reader.onload = (function (theFile) {
                                               return function (e) {
                                                   document.getElementById("img1").setAttribute("src", this.result);

                                                   setImageLoading(false);
                                                   console.log("image loaded!!")
                                               };
                                           })(f);

                                           // Read in the image file as a data URL.
                                           reader.readAsDataURL(f);
                                       }}/>
                                <Button variant="contained" component="span">
                                    آپلود تصویر
                                </Button>
                            </label>
                        </div>

                    </Grid>


                </Grid>


            </DialogContent>
            <DialogActions>
                <Button color="error" onClick={() => {
                    handleClose();
                }}>
                    انصراف
                </Button>
                <LoadingButton
                    loading={sending}
                    loadingPosition="end"
                    variant={'text'}
                    color="primary"
                    component="button"
                    onClick={() => {
                        sendDataToServer();
                    }}
                >
                    ثبت
                </LoadingButton>
            </DialogActions>
        </Dialog>
        <Snackbar open={openSnackBar1} autoHideDuration={2000}
                  onClose={handleCloseSnackBar1}
                  className={styles.snackBar}
                  anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        >
            <Alert
                severity="success"
                className={styles.txt}
            >
                {message}
            </Alert>
        </Snackbar>
        <Fab sx={fabStyle} color="primary" onClick={() => {
            setOpenDialog(true)
        }}>
            <AddRoundedIcon/>
        </Fab>
    </div>;
}

export default Slider;